export const USER_REDIRECTION_EVENTS = {
  VIEW_REDIRECTION_PAGE: 'view_redirection_page',
  SELECT_DOWNLOAD_APP: 'select_redirection_download_app',
} as const;
